import { Col, Row } from 'antd';
import React, { memo } from 'react';

import Text from '../../components/Text';
import { formatCurrencyToCompanyLocale } from '../../utils/numbers';
import BoundsIndicator from './BoundsIndicator';
import { GUTTER } from './constants';

const RateItem = memo(({ label, value, boundsKey, fieldsToCheck, getBounds, t, countryCode }) => (
  <Row justify="space-between" align="middle">
    <Col>
      <Text>{label}</Text>
    </Col>
    <Col>
      <Row align="middle" gutter={GUTTER.rate}>
        <Col>
          <Text variant="strong">
            {formatCurrencyToCompanyLocale(value, undefined, undefined, countryCode)}
          </Text>
        </Col>
        {fieldsToCheck.includes(boundsKey) && (
          <Col>
            <BoundsIndicator
              value={value}
              bounds={getBounds(boundsKey)}
              t={t}
              countryCode={countryCode}
            />
          </Col>
        )}
      </Row>
    </Col>
  </Row>
));

export default RateItem;
